@if (node.type === 1) {
    @if (node.attachedPanel) {
        <div class="lg-panel-grid__node__stack">
            <div class="lg-panel__header" (click)="_clickHeader(node)">
                <ng-container
                    *ngTemplateOutlet="panelHeaderTemplate; context: { $implicit: node }"
                ></ng-container>
            </div>
            @if (node.attachedPanel; as panel) {
                <ng-container
                    *ngTemplateOutlet="panel._panelTemplate; context: panel._context"
                ></ng-container>
            }
        </div>
    }
} @else {
    @if (_hasCollapsedParts) {
        <div class="lg-panel-grid__node__stack">
            <div class="lg-panel-grid__node__stack__top-headers">
                @for (
                    headerRow of node.headersAbove;
                    track _headerId(headerRow);
                    let last = $last
                ) {
                    <div
                        class="lg-panel-grid__node__stack__headers"
                        [class.lg-panel-grid__node__stack__headers--simple-row]="
                            node.simpleTabbedRow && last
                        "
                    >
                        @for (child of headerRow.nodes; track _nodeId(child)) {
                            <div
                                class="lg-panel__header lg-panel__header--tab-like"
                                [class.lg-panel__header--minimized]="
                                    child !== node.effectiveMaximizedChild
                                "
                                [class.lg-panel__header--auto]="headerRow.columnHeaders"
                                [style.flexBasis.%]="_getMinimizedHeaderRatio(headerRow, child)"
                                [style.width.%]="_getMinimizedHeaderRatio(headerRow, child)"
                                (click)="_clickHeader(child)"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        panelHeaderTemplate;
                                        context: { $implicit: child }
                                    "
                                ></ng-container>
                                <div class="lg-panel__header__shade"></div>
                            </div>
                        }
                    </div>
                }
            </div>
            @if (!node.simpleTabbedRow) {
                <div
                    class="lg-panel__header lg-panel__header--maximized"
                    (click)="_clickHeader(node.effectiveMaximizedChild!)"
                >
                    <ng-container
                        *ngTemplateOutlet="
                            panelHeaderTemplate;
                            context: { $implicit: node.effectiveMaximizedChild }
                        "
                    ></ng-container>
                </div>
            }
            @if (node.effectiveMaximizedChild?.attachedPanel; as panel) {
                <ng-container
                    *ngTemplateOutlet="panel._panelTemplate; context: panel._context"
                ></ng-container>
            }
            <div class="lg-panel-grid__node__stack__bottom-headers">
                @for (
                    headerRow of node.headersBelow;
                    track _headerId(headerRow);
                    let index = $index
                ) {
                    <div
                        class="lg-panel-grid__node__stack__headers"
                        [style.zIndex]="node.headersBelow.length - index"
                    >
                        @for (child of headerRow.nodes; track _nodeId(child)) {
                            <div
                                class="lg-panel__header lg-panel__header--minimized lg-panel__header--tab-like"
                                [class.lg-panel__header--auto]="headerRow.columnHeaders"
                                [style.flexBasis.%]="_getMinimizedHeaderRatio(headerRow, child)"
                                [style.width.%]="_getMinimizedHeaderRatio(headerRow, child)"
                                (click)="_clickHeader(child)"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        panelHeaderTemplate;
                                        context: { $implicit: child }
                                    "
                                ></ng-container>
                                <div class="lg-panel__header__shade"></div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    } @else {
        @for (child of node.children; track _nodeId(child)) {
            <lg-panel-grid-node
                [node]="child"
                [attr.panel-id]="child.definition.id"
            ></lg-panel-grid-node>
        }
    }
}

<ng-template #panelHeaderTemplate let-node>
    @if (node.attachedPanel; as panel) {
        @for (header of panel._visibleHeaders; track header.template) {
            <ng-container
                *ngTemplateOutlet="header.template; context: panel._context"
            ></ng-container>
        }
        <div class="lg-block__icons">
            @for (icon of panel._visibleIcons; track icon.template) {
                <ng-container
                    *ngTemplateOutlet="icon.template; context: panel._context"
                ></ng-container>
            }
            <lg-panel-resize-menu [node]="node"></lg-panel-resize-menu>
        </div>
    }
</ng-template>

<ng-template #panelBodyTemplate let-node> </ng-template>
